export default __webpack_public_path__ + "static/media/icons.d7b48993.svg";